import { noop } from 'lodash-es';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useEventReporter } from '~/event-reporter/EventReporter';
export const useUserInitiatedLogout = ()=>{
    const { reset } = useStoreActions();
    const { getState } = useStoreStatic();
    const { native, getNow } = useIoContext();
    const { sendEventToGtm } = useEventReporter();
    async function logOutUser() {
        sendEventToGtm('logout', {});
        await queuePushRemoval();
        await native.session.setJustLoggedOut();
        reset(true);
    }
    async function queuePushRemoval() {
        const { nativePushTokenInfo, userInfo } = getState();
        const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
        if (nativePushTokenInfo != null && userId != null) {
            await native.pushRemovalOutbox.put(nativePushTokenInfo, userId, getNow()).catch(noop);
        }
    }
    return {
        logOutUser
    };
};
